import {generateCallback} from '../util/appCallback';

// 开始录音
export function startRecord(option = {}) {
    if (this.openRecorderPlatform) {
        const globalMethodName = generateCallback(option, (base64, status, volume) => {
            const result = {
                code: -1,
                data: {
                    status,
                    base64: '',
                    time: 0
                }
            };
            if (~~status === 0 || ~~status === -3) {
                result.code = 0;
            }
            return result;
        });
        // 安卓：未结束或取消的再次开始的 bug，但结束后再开始，间隔太近也会出错，暂无处理方法。所以前端无法很好的做兼容，只能从客户端下手
        // IOS：未结束或取消，再次开始，不能重新录音
        this.openRecorderPlatform({
            status: 0,
            onVolume: option.onVolume || 0,
            receiveJS: globalMethodName
        });
    }
}


// 结束录音
// eslint-disable-next-line sonarjs/cognitive-complexity
export function stopRecord(option) {
    if (this.openRecorderPlatform) {
        const globalMethodName = generateCallback(option, (base64, status, millisecond, volume, hz) => {
            const result = {
                code: -1,
                data: {
                    status,
                    base64: '',
                    time: 0
                }
            };
            let volumes = [];
            let hzs = [];
            try {
                if (Object.prototype.toString.call(volume) === '[object Array]') {
                    volumes = volume;
                } else if (typeof volume === 'string') {
                    volumes = JSON.parse(volume);
                }
            } catch (e) {
                console.log('volume parse error');
            }
            try {
                if (Object.prototype.toString.call(hz) === '[object Array]') {
                    hzs = hz;
                } else if (typeof hz === 'string') {
                    hzs = JSON.parse(hz);
                }
            } catch (e) {
                console.log('hz parse error');
            }
            if (~~status === 1) {
                result.code = 0;
                // ios 轻聊：如果没有开始，直接调用结束，无上一次录音，返回字符串'(null)'
                if (base64 && base64 !== '(null)') {
                    result.data = {
                        status,
                        base64: `data:audio/mp3;base64,${base64}`,
                        time: millisecond,
                        volume: volumes,
                        hz: hzs
                    };
                }
            }
            return result;
        });
        this.openRecorderPlatform({
            status: 1,
            receiveJS: globalMethodName
        });
    }
}
// 取消录音
export function cancelRecord(option) {
    if (this.openRecorderPlatform) {
        const globalMethodName = generateCallback(option, (base64, status) => {
            const result = {
                code: -1,
                data: {
                    base64: '',
                    time: 0,
                    status
                }
            };
            if (~~status === -1) {
                result.code = 0;
            }
            return result;
        });
        this.openRecorderPlatform({
            status: -1,
            receiveJS: globalMethodName
        });
    }
}

export default {
    startRecord,
    stopRecord,
    cancelRecord
};
